import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layout
import DashboardLayout from "./components/DashboardLayout/DashboardLayout";

// Dashboard
import Dashboard from "./components/Dashboard/Dashboard";

// Customers
import CustomerForm from "./components/Customer/CustomerForm";
import CustomerList from "./components/Customer/CustomerList";
import ViewCustomer from "./components/Customer/ViewCustomer";

// Settings
import CompanyProfile from "./components/Settings/CompanyProfile";
import PermissionsPage from "./components/Settings/PermissionsPage";
import { PermissionProvider } from "./context/PermissionContext";

// Reports
import DailySalesPage from "./components/DailySales/DailySalesPage";


// Employees
import EmployeeWizard from "./components/Employee/EmployeeWizard";
import EmployeeList from "./components/Employee/EmployeeList";
import EmployeeView from "./components/Employee/EmployeeView";
import EmployeeContactForm from "./components/Employee/EmployeeContactForm";
import EmployeeEmploymentForm from "./components/Employee/EmployeeEmploymentForm";
import EmployeeTimingLeaveForm from "./components/Employee/EmployeeTimingLeaveForm";
import Attendance from "./components/Employee/Attendance";
import ShiftManagement from "./components/Employee/ShiftManagement";

// Bulk Sales
import BulkSalesList from "./components/BulkSales/BulkSalesList";
import BulkSaleForm from "./components/BulkSales/BulkSaleForm";

// Sales
import SalesForm from "./components/Sales/SalesForm";
import SalesList from "./components/Sales/SalesList";
import SalesModule from "./components/Sales/SalesModule";

// Refund
import RefundForm from "./components/Refund/RefundForm";
import RefundList from "./components/Refund/RefundList";
import RefundItem from "./components/Refund/RefundItem";

// Suppliers
import SupplierForm from "./components/SupplierForm/SupplierForm";
import SupplierList from "./components/SupplierForm/SupplierList";
import ViewSupplier from "./components/SupplierForm/ViewSupplier";

// Banks
import BankForm from "./components/Accounts/BankForm";
import BankList from "./components/Accounts/BankList";
import COAList from "./components/Accounts/COAList";
import COAForm from "./components/Accounts/COAForm";
import BankReconciliation from "./components/Accounts/BankReconciliation";
import ChequeManager from "./components/Accounts/ChequeManager";

// Inquiry
import InquiryForm from "./components/Inquiry/InquiryForm";
import InquiryList from "./components/Inquiry/InquiryList";
import InquiryDetail from "./components/Inquiry/InquiryDetail";

// Templates
import TemplatesList from "./components/VoucherTemplate/TemplatesList";
import TemplateSettings from "./components/VoucherTemplate/TemplateSettings";
import InvoiceTemplate from "./components/VoucherTemplate/InvoiceTemplate";
import ReceiptTemplate from "./components/VoucherTemplate/ReceiptTemplate";
import PaymentVoucherTemplate from "./components/VoucherTemplate/PaymentVoucherTemplate";

// Receipts
import ReceiptList from "./components/Receipts/ReceiptList";
import ReceiptForm from "./components/Receipts/ReceiptForm";
import ReceiptPage from "./components/VoucherTemplate/ReceiptPage";

// Payments
import PaymentList from "./components/Payments/PaymentList";
import PaymentForm from "./components/Payments/PaymentForm";
import PaymentVoucherPage from "./components/Pages/PaymentVoucherPage";

import JournalEntryForm from "./components/Transactions/JournalEntryForm";
import JournalEntryList from "./components/Transactions/JournalEntryList";
import ContraEntryForm from "./components/Transactions/ContraEntryForm";
import ContraEntryList from "./components/Transactions/ContraEntryList";
import PurchaseBillList from "./components/Transactions/PurchaseBillList";
import PurchaseBillForm from "./components/Transactions/PurchaseBillForm";

// Quotations
import QuotationList from "./components/Quotation/QuotationList";
import QuotationForm from "./components/Quotation/QuotationForm";
import QuotationDetail from "./components/Quotation/QuotationDetail";

import PnLPage from "./components/Reports/PnLPage";
import PnLComparisonPage from "./components/Reports/PnLComparisonPage";
import ExpenseReportPage from "./components/Reports/ExpenseReportPage";
import OutstandingReportPage from "./components/Reports/OutstandingReportPage";
import BalanceSheetPage from "./components/Reports/BalanceSheetPage";
import BalanceSheetComparisonPage from "./components/Reports/BalanceSheetComparisonPage";
import LedgerReportPage from "./components/Reports/LedgerReportPage";
import TrialBalancePage from "./components/Reports/TrialBalancePage";
import TrialBalanceComparisonPage from "./components/Reports/TrialBalanceComparisonPage";
import VATReportPage from "./components/Reports/VATReportPage";
import CashFlowPage from "./components/Reports/CashFlowPage";
import PDCReportPage from "./components/Reports/PDCReportPage";
import AgingReport1Page from "./components/Reports/AgingReport1Page";
import ServiceReportPage from "./components/Reports/ServiceReportPage";
import MiscReportPage from "./components/Reports/MiscReportPage";
import SalesPurchaseSummaryPage from "./components/Reports/SalesPurchaseSummaryPage";
import BusinessOverviewPage from "./components/Reports/BusinessOverviewPage";
import BSPRegisterPage from "./components/Reports/BSPRegisterPage";
import CreditNoteList from "./components/Notes/CreditNoteList";
import CreditNoteForm from "./components/Notes/CreditNoteForm";
import DebitNoteList from "./components/Notes/DebitNoteList";
import DebitNoteForm from "./components/Notes/DebitNoteForm";

// Others
import PnLTransferPage from "./components/Others/PnLTransferPage";
import PosSettlementPage from "./components/Others/PosSettlementPage";
import ChequeReturnsPage from "./components/Others/ChequeReturnsPage";

// Auth
import LoginSignup from "./components/LoginSignup/LoginSignup";

// WhatsApp
import WhatsAppChat from "./components/WhatsApp/WhatsAppChat";
import TaskManager from "./components/TaskManager/TaskManager";

// Calendar
import CalendarPage from "./components/Calendar/CalendarPage";

// Tax
import TaxSettings from "./pages/TaxSettings";
import TaxReport from "./pages/TaxReport";
// Documents
import DocumentList from "./components/DocumentManagement/DocumentList";
import DocumentUpload from "./components/DocumentManagement/DocumentUpload";
import DocumentDetail from "./components/DocumentManagement/DocumentDetail";
import DocumentEdit from "./components/DocumentManagement/DocumentEdit";
import ExpiryAlerts from "./components/DocumentManagement/ExpiryAlerts";



function App() {
  const isLoggedIn = !!localStorage.getItem("access_token");

  return (
    <PermissionProvider>
    <Routes>
      {/* Root Redirect */}
      <Route
        path="/"
        element={
          isLoggedIn
            ? <Navigate to="/dashboard" />
            : <Navigate to="/auth/login" />
        }
      />

      {/* Auth */}
      <Route path="/auth/login" element={<LoginSignup />} />
      <Route path="/auth/register" element={<LoginSignup />} />

      {/* Protected Dashboard */}
      <Route
        path="/dashboard"
        element={
          isLoggedIn
            ? <DashboardLayout />
            : <Navigate to="/auth/login" />
        }
      >
        <Route index element={<Dashboard />} />

        {/* WhatsApp */}
        <Route path="whatsapp" element={<WhatsAppChat />} />
        <Route path="tasks" element={<TaskManager />} />
        <Route path="calendar" element={<CalendarPage />} />

        {/* Customers */}
        <Route path="customers">
          <Route path="new" element={<CustomerForm />} />
          <Route path="list" element={<CustomerList />} />
          <Route path=":id" element={<ViewCustomer />} />
          <Route path="edit/:id" element={<CustomerForm />} />
        </Route>

        {/* Inquiry */}
        <Route path="inquiries">
          <Route path="new" element={<InquiryForm />} />
          <Route path="list" element={<InquiryList />} />
          <Route path=":id" element={<InquiryDetail />} />
          <Route path="edit/:id" element={<InquiryForm />} />
        </Route>

        {/* Quotations */}
        <Route path="quotations">
          <Route path="list" element={<QuotationList />} />
          <Route path="new" element={<QuotationForm />} />
          <Route path="edit/:id" element={<QuotationForm />} />
          <Route path=":id" element={<QuotationDetail />} />
        </Route>

        {/* Settings */}
        <Route path="settings">
          <Route path="company-profile" element={<CompanyProfile />} />
          <Route path="permissions" element={<PermissionsPage />} />
        </Route>

        {/* Tax */}
        <Route path="tax">
          <Route path="settings" element={<TaxSettings />} />
          <Route path="report" element={<TaxReport />} />
        </Route>

        {/* Reports */}
        <Route path="reports">
          <Route path="daily-sales" element={<DailySalesPage />} />
          <Route path="pnl" element={<PnLPage />} />
          <Route path="pnl-comparison" element={<PnLComparisonPage />} />
          <Route path="expenses" element={<ExpenseReportPage />} />
          <Route path="expense" element={<ExpenseReportPage />} />
          <Route path="outstanding" element={<OutstandingReportPage />} />
          <Route path="cash-flow" element={<CashFlowPage />} />
          <Route path="ledger" element={<LedgerReportPage />} />
          <Route path="trial-balance" element={<TrialBalancePage />} />
          <Route path="trial-balance-comparison" element={<TrialBalanceComparisonPage />} />
          <Route path="trial-balance/comparison" element={<TrialBalanceComparisonPage />} />
          <Route path="vat" element={<VATReportPage />} />
          <Route path="balance-sheet" element={<BalanceSheetPage />} />
          <Route path="balance-sheet-comparison" element={<BalanceSheetComparisonPage />} />
          <Route path="pdc-payments" element={<PDCReportPage />} />
          <Route path="aging1" element={<AgingReport1Page />} />
                      <Route path="aging" element={<AgingReport1Page />} />
          <Route path="aging" element={<AgingReport1Page />} />
          <Route path="service-report" element={<ServiceReportPage />} />
          <Route path="misc" element={<MiscReportPage />} />
          <Route path="sales-purchase" element={<SalesPurchaseSummaryPage />} />
          <Route path="business-overview" element={<BusinessOverviewPage />} />
          <Route path="overview" element={<BusinessOverviewPage />} />
          <Route path="bsp-register" element={<BSPRegisterPage />} />
          <Route path="bsp-ticket" element={<BSPRegisterPage />} />

        </Route>


        {/* Employees */}
        <Route path="employees">
          <Route path="new" element={<EmployeeWizard />} />
          <Route path="list" element={<EmployeeList />} />
          <Route path=":id" element={<EmployeeView />} />
          <Route path="contact" element={<EmployeeContactForm />} />
          <Route path="employment" element={<EmployeeEmploymentForm />} />
          <Route path="timings-leave" element={<EmployeeTimingLeaveForm />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="shifts" element={<ShiftManagement />} />
        </Route>


        {/* Documents */}
        <Route path="documents">
          <Route path="list" element={<DocumentList />} />
          <Route path="upload" element={<DocumentUpload />} />
          <Route path="expiry-alerts" element={<ExpiryAlerts />} />
          <Route path=":id" element={<DocumentDetail />} />
          <Route path="edit/:id" element={<DocumentEdit />} />
        </Route>
        {/* Bulk Sales */}
        <Route path="bulk-sales">
          <Route index element={<BulkSalesList />} />
          <Route path="list" element={<BulkSalesList />} />
          <Route path="new" element={<BulkSaleForm />} />
          <Route path="edit/:id" element={<BulkSaleForm />} />
        </Route>

        {/* Sales */}
        <Route path="sales">
          <Route path="new" element={<SalesForm />} />
          <Route path="list" element={<SalesList />} />
          <Route path="edit/:id" element={<SalesForm />} />
        </Route>

        {/* Refund */}
        <Route path="refund">
          <Route path="new" element={<RefundForm />} />
          <Route path="list" element={<RefundList />} />
          <Route path=":id" element={<RefundItem />} />
        </Route>

        {/* Suppliers */}
        <Route path="suppliers">
          <Route path="new" element={<SupplierForm />} />
          <Route path="list" element={<SupplierList />} />
          <Route path=":id" element={<ViewSupplier />} />
          <Route path="edit/:id" element={<SupplierForm />} />
        </Route>

        {/* Banks */}
        <Route path="banks">
          <Route path="new" element={<BankForm />} />
          <Route path="list" element={<BankList />} />
        </Route>

        {/* Accounts / Reconciliation */}
        <Route path="accounts">
          <Route path="unreconciled" element={<Navigate to="/dashboard/accounts/bank-reconciliation" replace />} />
          <Route path="bank-reconciliation" element={<BankReconciliation />} />
          <Route path="cheque-manager" element={<ChequeManager />} />
        </Route>

        {/* Chart of Accounts */}
        <Route path="coa">
          <Route path="list" element={<COAList />} />
          <Route path="new" element={<COAForm />} />
          <Route path="edit/:id" element={<COAForm />} />
        </Route>

        {/* Receipts */}
        <Route path="receipts">
          <Route path="new" element={<ReceiptForm />} />
          <Route path="list" element={<ReceiptList />} />
          <Route path="view/:id" element={<ReceiptPage />} />
        </Route>

        {/* Payments */}
        <Route path="payments">
          <Route path="new" element={<PaymentForm />} />
          <Route path="list" element={<PaymentList />} />
          <Route path="view/:id" element={<PaymentVoucherPage />} />
        </Route>

        {/* Transactions */}
        <Route path="transactions">
          <Route path="purchase-bills">
            <Route path="new" element={<PurchaseBillForm />} />
            <Route path="list" element={<PurchaseBillList />} />
          </Route>
          {/* Journal Entries */}
          <Route path="journal/new" element={<JournalEntryForm />} />
          <Route path="journal/list" element={<JournalEntryList />} />
          
          {/* Contra Entries */}
          <Route path="contra/new" element={<ContraEntryForm />} />
          <Route path="contra/list" element={<ContraEntryList />} />
        </Route>

        {/* Notes */}
        <Route path="credit-notes">
          <Route path="list" element={<CreditNoteList />} />
          <Route path="new" element={<CreditNoteForm />} />
          <Route path="edit/:id" element={<CreditNoteForm />} />
        </Route>
        <Route path="debit-notes">
          <Route path="list" element={<DebitNoteList />} />
          <Route path="new" element={<DebitNoteForm />} />
          <Route path="edit/:id" element={<DebitNoteForm />} />
        </Route>

        {/* Others */}
        <Route path="others">
          <Route path="pnl-transfer" element={<PnLTransferPage />} />
          <Route path="pos-settlement" element={<PosSettlementPage />} />
          <Route path="cheque-returns" element={<ChequeReturnsPage />} />
        </Route>

        {/* Templates */}
        <Route path="templates">
          <Route index element={<TemplatesList />} />
          <Route path="edit/:id" element={<TemplateSettings />} />
        </Route>
      </Route>

      {/* 404 */}
      <Route
        path="*"
        element={
          <div className="text-center mt-5">
            404 - Page Not Found
          </div>
        }
      />
    </Routes>
    </PermissionProvider>
  );
}

export default App;
